import React from "react";
import { Globe, Heart } from "lucide-react";

const Innovations = () => {
  return (
    <section className="py-12 flex flex-col gap-12 justify-center px-6">

      {/* Our Vision Section */}
      <div className="bg-[#023020] border border-gray-200 shadow-md rounded-xl p-8 max-w-2xl mx-auto text-center">
  <h2 className="text-white text-sm font-semibold tracking-wide mb-3">
    Our Vision
  </h2>

  <h3 className="text-white text-xl md:text-2xl font-bold leading-relaxed">
    To become the leading platform for trusted global freelance work—powered by{" "}
    <span className="text-[#ee009d] font-semibold">verification</span>,{" "}
    structured{" "}
    <span className="text-[#ee009d] font-semibold">learning</span>, and smart{" "}
    <span className="text-[#2AA100] font-semibold">matching</span>.
  </h3>
</div>





    </section>
  );
};

export default Innovations;
